class PasswordStrengthRuleElement {
    private ruleElement: Element;
    private readonly label: string | undefined;

    constructor(ruleElement: Element) {
        this.ruleElement = ruleElement;
        const labelElement = ruleElement.getAttribute("data-js-label");
        if (labelElement) {
            this.label = labelElement;
        }
    }

    isFulfilled(validatedRules: Record<string, boolean>): boolean {
        if (this.label) {
            if (validatedRules[this.label]) {
                /*                                                  */
                return true;
            }
        }
        return false;
    }

    markFulfilled() {
        this.ruleElement.classList.add("fulfilled");
    }

    unmarkFulfilled() {
        this.ruleElement.classList.remove("fulfilled");
    }
}

export default PasswordStrengthRuleElement;
